import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as CopySVG } from 'icons/copy.svg';

import './style.css';

const Address = ({
  name,
  value,
  className,
  label,
  disabled,
  valid,
  validationText = 'This question is required!',
  isCopiable = false,
  onSelect,
  onChange,
}) => {
  const [internalValue, setInternalValue] = useState(value || '');

  useEffect(() => {
    const initializeAutocomplete = () => {
      const input = document.getElementById('address');
      if (!input) {
        console.error('Autocomplete input element not found');
        return;
      }

      const autocomplete = new window.google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: 'fr' },
      });

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();

        setInternalValue(place.formatted_address);
        onSelect(place);
      });
    };

    initializeAutocomplete();
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    toast('Copied to clipboard');
  };

  return (
    <div className="input-group">
      <label htmlFor={name}>{label}</label>
      <input
        id="address"
        type="text"
        value={internalValue}
        name={name}
        className={className}
        disabled={disabled}
        placeholder=""
        onChange={(e) => {
          const { value } = e.target;
          onChange(e);
          setInternalValue(value);
        }}
      />
      {isCopiable && (
        <div
          style={{ top: '33px' }}
          data-rh="Copy"
          className="pointer absolute inset-y-0 right-0 flex items-center pr3"
          onClick={() => handleCopy()}
        >
          <CopySVG className="h5 w5 midgrey" aria-hidden="true" />
        </div>
      )}

      {!valid && <span className="error">{validationText}</span>}
    </div>
  );
};

Address.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  valid: PropTypes.bool,
  validationText: PropTypes.string,
  isCopiable: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Address;
